import React, { lazy, Suspense, useLayoutEffect } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import useUserStore from 'store/useUserStore';
import useAuth from 'hooks/useAuth';
import Loader from 'components/Elements/Loader/Loader';
import {
  consumePostLoginRedirectForKey,
  isAuthEntryPath,
  isSafeInternalPath,
} from 'utils/postLoginRedirect';
import publicRoutes from './public';
import protectedRoutes from './protected';

const SclaOrientationFormsList = lazy(
  () =>
    import(
      'features/scla-orientation-forms-public/routes/SclaOrientationFormsList'
    ),
);

// const AiImageChatEntry = lazy(
//   () => import('features/ai-image-chat/routes/AiImageChatEntry'),
// );

const universalRoutes = [
  {
    path: '/scla-resources',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <SclaOrientationFormsList />
      </Suspense>
    ),
  },
  // {
  //   path: '/ai-image-chat/*',
  //   element: (
  //     <Suspense fallback={<Loader theme="light" isVisible fullscreen={false} />}>
  //       <AiImageChatEntry />
  //     </Suspense>
  //   ),
  // },
];

function GuestRoutes() {
  return useRoutes([...universalRoutes, ...publicRoutes]);
}

function AuthedRoutes() {
  return useRoutes([...universalRoutes, ...protectedRoutes]);
}

export default function AppRoutes() {
  const { isDone } = useAuth();
  const user = useUserStore(s => s.user);
  const location = useLocation();
  const navigate = useNavigate();

  // Google popup can set the profile while the URL is still the sign-in page.
  // Swap the route tree, then leave that page in the same turn.
  useLayoutEffect(() => {
    if (!user || !isAuthEntryPath(location.pathname)) return;
    const raw = consumePostLoginRedirectForKey(location.key) ?? '/home';
    const pathOnly = raw.split('?')[0].split('#')[0];
    const target = isSafeInternalPath(raw) && !isAuthEntryPath(pathOnly) ? raw : '/home';
    if (pathOnly === location.pathname) return;
    navigate(target, { replace: true });
  }, [user, location.pathname, location.key, navigate]);

  if (!isDone) {
    return <Loader theme="dark" isVisible fullscreen />;
  }

  // Separate components so the matched tree is built after login, not reused
  // from the sign-in page.
  return user ? <AuthedRoutes /> : <GuestRoutes />;
}
